import React, { useState, useEffect } from "react";
import Back from "../../images/Background.jpg";

function Pageone() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div
      className={`relative min-h-[600px] w-full overflow-hidden transition-opacity duration-1000 ease-in-out ${
        isVisible ? "opacity-100" : "opacity-0"
      }`}
      style={{
        backgroundImage: `url(${Back})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        position: "relative",
      }}
    >
      {/* Dark overlay for better text readability */}
      <div className="absolute inset-0 bg-black bg-opacity-50"></div>

      {/* Content Container */}
      <div className="relative h-full container mx-auto px-6 lg:px-12 py-20 mt-10">
        <div className="max-w-2xl flex flex-col justify-center h-full">
          <h1
            className="font-degular font-bold 
                        text-3xl sm:text-4xl md:text-5xl lg:text-6xl 
                        leading-tight text-white
                        tracking-tight"
          >
            Turn your Dreams into <br className="hidden sm:block" />
            something Beautiful
          </h1>

          <p
            className="text-white/90 
                        text-base sm:text-lg md:text-xl 
                        mt-6 sm:mt-8 
                        leading-relaxed
                        max-w-xl"
          >
            Streamline your business processes and simplify your interactions
            with Vendors and customers.
          </p>

          <button
            onClick={() => (window.location.href = "https://home.qbicles.com")}
            className="mt-8 sm:mt-10 
                            bg-white text-[#4987fa] 
                            border-2 border-[#4987fa] 
                            px-6 py-3 sm:px-8 sm:py-4
                            rounded-xl text-base sm:text-lg
                            font-medium 
                            hover:bg-[#4987fa] hover:text-white 
                            transition-all duration-300 ease-in-out 
                            shadow-lg hover:shadow-xl
                            transform hover:scale-105
                            w-fit
                            cursor-pointer"
          >
            Get Started
          </button>
        </div>
      </div>
    </div>
  );
}

export default Pageone;
